import instanceAPI from 'services/apis/axiosconfig';

export const getReviveItems = (max) => {
  const request = instanceAPI.get(`/public/get-revive-experiences?maxResults=${max}`);
  return request.then((res) => ({
    ...res,
    data: {
      data: res.data.reviveExperiences,
    },
  }));
};
